export default {
  推荐66人: `66명 친구 초대하고 바르사에 초대받기`,
  成为EBC推荐官: "EBC 추천인에서 바르사 VIP로",
  立即参与: "지금 가입하기 ",
  活动规则与要求: "이벤트 규칙",
  每一次推荐: "한 번의 초대로 바르사를 향한 한 걸음을 내딛다",
  参与规则: "참여 방법",
  成为EBC推荐官并邀请66人: "EBC 초대자가 되어 66명의 친구를 초대하기",
  所有被邀请人均入金大于等于$500: `초대된 친구가 최소 $500을 입금하고 거래를 완료함`,
  参与方法: "참여 절차",
  立即推荐: "지금 바로 친구들을 초대하고 전설적인 순간을 함께 하세요",
  登录EBC用户中心: "EBC 고객 포털에 로그인",
  "进入“大赛推荐官”活动页面": `"친구초대 이벤트" 클릭`,
  生成您的邀请链接或二维码: "전용 링크 혹은 QR코드 생성",
  巴萨荣耀之旅: "FC 바르셀로나로 향하는 챔피언의 길",
  每笔订单都是攻守博弈的艺术: `대회 우승자는 FC 바르셀로나의 홈구장인 캄프 누에 초대됩니다.`,
  活动时间: "이벤트 기간",
  "2025年2月22日": "2025년 2월 22일 01:00:00(MT4/MT5기준)-2025년 8월(MT4/MT5기준)",
  活动规则: "이벤트 규칙",
  ruleList: [
    `해당 이벤트는 "친구초대 이벤트" 및 다른 이벤트와 중복 진행 가능합니다. `,
    "초대된 친구가 입금 및 거래를 완료해야 하며, 제 3자의 이체는 무효 처리 됩니다.",
    "부정행위 적발 시 당사는 해당 참가자의 참가 자격을 박탈할 권리가 있습니다.",
    "추천을 통해 등록된 계정은 대리인을 이전할 수 없습니다.",
    "보상은 활성화된 계정을 기준으로 하며, VIP 관람석 초대에는 항공권과 숙박이 포함됩니다.",
    "본 이벤트의 최종 해석권은 EBC에 있습니다",
  ],
};
